export function Conservative(props: { className?: string }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      className={props.className}
      viewBox="0 0 20 20"
      fill="none"
    >
      <path
        d="M2.4375 2.4375V15.4375C2.4375 15.8685 2.6087 16.2818 2.91345 16.5865C3.2182 16.8913 3.63152 17.0625 4.0625 17.0625H17.0625"
        stroke="currentColor"
        strokeWidth="1.3"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M14.1637 9.32298C15.0537 8.70415 15.8351 7.71311 16.124 7.38253C16.1736 7.32681 16.1996 7.25458 16.1968 7.18047C16.194 7.10636 16.1626 7.03591 16.1089 6.98339C15.5245 6.40793 14.4288 5.7062 13.7242 5.27968"
        stroke="currentColor"
        strokeWidth="1.3"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M5.9568 13.2951C7.33369 9.54034 9.73893 7.24315 15.8362 7.2644"
        stroke="currentColor"
        strokeWidth="1.3"
        strokeLinecap="round"
      />
    </svg>
  );
}
